<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{ `${$t("modal.station_config.speaker.edit")} ${props.name}` }}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>


      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.name')" v-model="model.name" maxLength="50">
          <label for="name">{{$t("modal.station_config.station.name")}} 
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="callSign" id="callSign" autocomplete="off" :class="{'invalid': submitted && v$.model.callSign.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.callSign')" v-model="model.callSign" maxLength="50">
          <label for="callSign">{{$t("modal.station_config.station.callSign")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="number" name="commercialBreakMaxTime" id="commercialBreakMaxTime" autocomplete="off" :class="{'invalid': submitted && v$.model.commercialBreakMaxTime.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.commercialBreakMaxTime')" v-model="model.commercialBreakMaxTime">
          <label for="commercialBreakMaxTime">{{$t("modal.station_config.station.commercialBreakMaxTime")}} 
            <small v-if="submitted && v$.model.commercialBreakMaxTime.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <label for="images" class="drop-container" v-if="model.image == '' || !model.image">
        <span v-html="$t('modal.station_config.station.drop')"></span>
        <input type="file" id="images" accept="image/*" @change="uploadImage">
      </label>

      <div class="drop-container selected" v-else>
        <div class="container-image">
          <img :src="getUrlImage(model.image)" alt="image-station" style="width: 100%">
        </div>
        
        <i class="material-icons remove" @click="model.image = ''">cancel</i>
      </div>

      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ $t("modal.save") }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.station_config.station.${error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { maxLength, minValue, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import storage from "@/plugins/azure-storage";

export default {
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const submitted = ref(false);
    const model = ref({
      name: '',
      callSign: '',
      commercialBreakMaxTime: 0,
      image: ''
    })

    onMounted(() => {
      if (props.value) model.value = Object.assign({}, props.value);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    function getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_USER}${path}`
    }

    async function uploadImage(event) {
      const file = event.target.files[0]
      if(!file) return false;
      store.dispatch('loading_setActive', true);
      try {
        const imageName = await storage.updateFile(file);
        model.value.image = imageName; 
      } catch (error) {
        store.dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('notifications.uploadStationLogoError')}`, title: 'ERROR', error: true});
      } finally {
        store.dispatch('loading_setActive', false);
      }
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch('station_update', model.value);
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      v$,
      props,
      model,
      submitted,
      saveAndClose,
      closeModal,
      uploadImage,
      getUrlImage
    }
  },
	validations () {
    return {
      model: {
        name: {required, maxLengthValue: maxLength(50)},
				callSign: {maxLengthValue: maxLength(50)},
        commercialBreakMaxTime: {required, minValueValue: minValue(1)}
			}
    }
  }
};
</script>
<style lang="scss">
.drop-container {
  text-align: center;

  small {
    color: white;
  } 
}
</style>